export const PLANS = {
    free: { id: 'free', name: 'Free', tabLimit: 2, priceUsdtMonthly: 0 },
    pro: { id: 'pro', name: 'Pro', tabLimit: 5, priceUsdtMonthly: 10 },
    desk: { id: 'desk', name: 'Desk', tabLimit: 10, priceUsdtMonthly: 20 },
};
/** Lifetime WEEX notional → extra tab tiers (does not change paid planId). */
export const VOLUME_TAB_UNLOCKS = [
    { minVolumeUsdt: 150_000, tabLimit: PLANS.pro.tabLimit },
    { minVolumeUsdt: 300_000, tabLimit: PLANS.desk.tabLimit },
];
export const volumeTabLimit = (tradedVolumeUsdt) => {
    const vol = Number(tradedVolumeUsdt) || 0;
    let unlocked = 0;
    for (const tier of VOLUME_TAB_UNLOCKS) {
        if (vol >= tier.minVolumeUsdt)
            unlocked = Math.max(unlocked, tier.tabLimit);
    }
    return unlocked;
};
export const effectiveTabLimit = (planId, tradedVolumeUsdt = 0) => {
    const base = (planId in PLANS ? PLANS[planId] : PLANS.free).tabLimit;
    return Math.max(base, volumeTabLimit(tradedVolumeUsdt));
};
export const canOpenTab = (planId, currentTabs, tradedVolumeUsdt = 0) => currentTabs < effectiveTabLimit(planId, tradedVolumeUsdt);
/** Plan row for API/UI: paid plan identity + effective tabLimit from volume unlocks. */
export const resolveEffectivePlan = (planId, tradedVolumeUsdt = 0) => {
    const base = planId in PLANS ? PLANS[planId] : PLANS.free;
    const volumeUnlockedTabs = volumeTabLimit(tradedVolumeUsdt);
    const tabLimit = Math.max(base.tabLimit, volumeUnlockedTabs);
    return {
        ...base,
        tabLimit,
        tradedVolumeUsdt: Number(tradedVolumeUsdt) || 0,
        baseTabLimit: base.tabLimit,
        volumeUnlockedTabs,
    };
};
